export default "__VITE_ASSET__BMWD5jzU__"